import styled from 'styled-components';

import { theme } from '../../../global';

export const HeaderContainer = styled.div`
  background-color: ${theme.colors.header};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 72px;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  max-width: ${theme.content.max_width};
`;

export const HeaderTitle = styled.h1`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.white};

  @media (max-width: 768px) {
    display: none;
  }
`;
